import { Box } from '@primer/react';
import { useIsMobile } from '../hooks/useIsMobile';

const fillSx = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

// Full-bleed hero background. Renders the autoplaying video on desktop, but
// falls back to the static poster image on mobile, where autoplaying video
// is unreliable and can stall the rest of the page from loading/scrolling.
function HeroBackground({ videoSrc, poster, loop = true }) {
  const isMobile = useIsMobile();

  if (isMobile || !videoSrc) {
    return <Box as="img" src={poster} alt="" sx={fillSx} />;
  }

  return (
    <Box as="video" autoPlay loop={loop} muted playsInline poster={poster} sx={fillSx}>
      <source src={videoSrc} type="video/webm" />
    </Box>
  );
}

export default HeroBackground;
